import { useCallback, useState } from 'react';

// Runs async mutation work, tracking a busy flag and the last error message.
export default function useAsyncTask() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(async (fn, fallbackMessage = 'Something went wrong') => {
    setBusy(true);
    setError(null);
    try {
      await fn();
    } catch (e) {
      setError(e.message || fallbackMessage);
    } finally {
      setBusy(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return { run, busy, error, clearError };
}
